__turbopack_context__.v({
  "blok-big-title": "product-tag-module__79E6Pq__blok-big-title",
  "blok-subtitle": "product-tag-module__79E6Pq__blok-subtitle",
  "blok-title": "product-tag-module__79E6Pq__blok-title",
  "container": "product-tag-module__79E6Pq__container",
  "desktop-only": "product-tag-module__79E6Pq__desktop-only",
  "free": "product-tag-module__79E6Pq__free",
  "mobile-only": "product-tag-module__79E6Pq__mobile-only",
  "sale": "product-tag-module__79E6Pq__sale",
  "tag": "product-tag-module__79E6Pq__tag",
});
